import React from 'react';

import { Box, Checkbox, FormikField, Input, Text } from '@betterment/samba-react';
import { useFormikContext } from 'formik';

import { FormikFileUpload } from '../../formik/FormikFileUpload';

import type { ReplaceClientAgreementFormValues } from './ReplaceClientAgreementPage';

const FileUploadWithNameSync: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<ReplaceClientAgreementFormValues>();

  const handleFileChange = (file: File | null) => {
    if (file && values.useUploadedPdfName) {
      void setFieldValue('documentName', file.name);
    }
  };

  return <FormikFileUpload name="pdfFile" acceptedFileTypes=".pdf" onChange={handleFileChange} />;
};

export const AgreementFileSection: React.FC = () => {
  const { values, setFieldValue, isSubmitting } = useFormikContext<ReplaceClientAgreementFormValues>();

  return (
    <Box
      css={{
        p: 'space.300',
        borderColor: 'border.weak',
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderRadius: 'medium',
        display: 'flex',
        flexDirection: 'column',
        gap: 'space.300',
      }}
    >
      <Box>
        <Text variant="text100" css={{ fontWeight: 'medium', display: 'block' }}>
          Client agreement
        </Text>
        <Text variant="text100" css={{ mt: 'space.100', display: 'block' }}>
          Ensure this document is signed and executed by your firm. Otherwise, you are responsible for executing it with
          your clients outside of Betterment.
        </Text>
      </Box>

      <FormikField name="pdfFile">
        <FormikField.Label>
          <Text variant="text100">Upload PDF</Text>
        </FormikField.Label>
        <FormikField.Control>
          <FileUploadWithNameSync />
        </FormikField.Control>
        <FormikField.ErrorMessage />
      </FormikField>

      <Box>
        <FormikField name="documentName">
          <FormikField.Label>
            <Text variant="text100">Document name</Text>
          </FormikField.Label>
          <FormikField.Control>
            <Input name="documentName" type="text" disabled={values.useUploadedPdfName || isSubmitting} />
          </FormikField.Control>
          <FormikField.ErrorMessage />
        </FormikField>

        <Checkbox
          css={{ mt: 'space.200' }}
          checked={values.useUploadedPdfName}
          onCheckedChange={(checked: boolean) => {
            void setFieldValue('useUploadedPdfName', checked);
            if (checked && values.pdfFile) {
              void setFieldValue('documentName', values.pdfFile.name);
            }
          }}
        >
          <Checkbox.Control />
          <Checkbox.Label>
            <Text variant="text100">Use uploaded PDF name</Text>
          </Checkbox.Label>
        </Checkbox>
      </Box>
    </Box>
  );
};
